function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DynamicListingComponent.css';
import React from 'react';
import { get } from '../../utils';
import { withRouter } from 'react-router-dom';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import FilterBlock from './FilterBlock';
import FeaturedResultItem from './FeaturedResultItem';
import SeeMoreButton from './SeeMoreButton';
import ResultItem from './ResultItem';
import { pick } from '../../utils';
import LoadMore from './LoadMore';
import { qsToObject } from '../../utils/querystring';
import { tealiumMergeClickData, tealiumClickFunc } from '../../utils/tealium';
import { addQueryStringMultiple, splitter } from "../Listing";
export let FacetWidgetType = /*#__PURE__*/function (FacetWidgetType) {
  FacetWidgetType["MULTI_TOGGLE"] = "multiToggle";
  FacetWidgetType["SINGLE_TOGGLE"] = "singleToggle";
  FacetWidgetType["MULTI_SELECT"] = "multiSelect";
  FacetWidgetType["SINGLE_SELECT"] = "singleSelect";
  return FacetWidgetType;
}({});

// Because we are trying to cover three content types via one component, we ask for all possible
// index properties and mark as optional those which might not be in curtain types.
// E.h. Legislations do not have headerimage property, but PressReleases do.

// @see graphQl definition

// @see graphQl definition

const getFilterFromCheckboxes = filtersArray => {
  const filtersFromCheckboxes = {};

  // eslint-disable-next-line array-callback-return
  filtersArray.map(filterDefinition => {
    if (filterDefinition.taxonomyType) {
      filtersFromCheckboxes[filterDefinition.taxonomyType.targetItem.filterName.value] = filtersFromCheckboxes[filterDefinition.taxonomyType.targetItem.filterName.value] || [];
      filtersFromCheckboxes[filterDefinition.taxonomyType.targetItem.filterName.value].push(filterDefinition.filterValue.value);
    }
  });
  return filtersFromCheckboxes;
};

/**
 * This is universal component that covers cases like:
 *  - List of Articles (specify via settingsItem.indexSource.targetItem.indexName.value)
 *  - List of PressReleases
 *  - List of Legislations
 *  - Optional UI Filter block if sitecore provides settingsItem.indexSource.targetItem.availableFacets
 *  - Featured items highlight if sitecore provides settingsItem.numberOfFeaturedItems.value
 *  - Predefined or Context-based default filtration
 *  - Optional Load more button
 *  - Optional "Go to full list" button
 *  - etc
 */
class DynamicListingComponent extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      hits: [],
      facets: {},
      nbHits: 0,
      nbPages: 0,
      filters: {},
      page: 0,
      algoliaModule: null
    };
    this.context = void 0;
    this.setFilters = filters => {
      const url = new URL(window.location.href);
      for (const filter in this.state.filters) {
        url.searchParams.delete(filter);
      }
      this.props.history.push(`${url.pathname}${url.search}${url.hash}`);
      if (Object.keys(filters).length) {
        for (const facet in filters) {
          addQueryStringMultiple(facet, filters[facet], this.props.history);
        }
      } else {
        this.props.history.push(`${url.pathname}${url.hash}`);
      }
      this.setState({
        filters,
        // Reset pagination, because we are going to show completely new set of results and nbHits will be different.
        page: 0
      });
    };
    this.loadMore = () => {
      if (this.state.page < this.state.nbPages) {
        this.setState(prevState => ({
          page: prevState.page + 1
        }));
      }
    };
    this.getMergedValidatedFilters = () => {
      const language = this.context.language || 'en';
      const contextItem = this.props.fields.data.contextItem;
      const queryParams = qsToObject(this.props.location.search);
      const hasPredefinedFilters = Boolean(this.props.fields.data.settingsItem.filterBy);
      const predefinedFiltersArray = hasPredefinedFilters ? this.props.fields.data.settingsItem.filterBy.targetItems : [];
      const predefinedFilters = getFilterFromCheckboxes(predefinedFiltersArray);
      const contextFiltersArray = contextItem ? Object.keys(contextItem).map(itemName => {
        if (contextItem[itemName].targetItem) {
          return [contextItem[itemName].targetItem];
        } else if (contextItem[itemName].targetItems) {
          return contextItem[itemName].targetItems;
        }
        return [];
      }).flat(2) : [];
      const contextFilters = getFilterFromCheckboxes(contextFiltersArray);
      const availableFilterNamesForIndex = this.props.fields.data.settingsItem.indexSource.targetItem.availableFilters.targetItems.map(filterDefinition => filterDefinition.filterName ? filterDefinition.filterName.value : '').filter(str => !!str);

      // Filter only by allowed filters, to avoid empty search results or other problems.
      // After we merge language, filters from facets, and from component configuration, remove those which are not allowed.
      const result = _objectSpread({
        _language: [language]
      }, pick(_objectSpread(_objectSpread(_objectSpread({}, this.state.filters), predefinedFilters), contextFilters), availableFilterNamesForIndex));

      // If there is tags in URL, lets add it as default filter.
      if (queryParams.tags) {
        result.tags = [...(result.tags || []), queryParams.tags].filter((value, index, self) => self.indexOf(value) === index);
      }
      return result;
    };
    this.loadSearchResults = () => {
      const settingsItem = get(this.props, 'fields.data.settingsItem');
      if (!settingsItem) {
        return;
      }
      const algoliaModule = this.state.algoliaModule;
      if (!algoliaModule) {
        console.warn('Algolia module not loaded');
        return;
      }
      const indexNameSuffix = settingsItem.indexSource.targetItem.indexName.value;
      const numberOfListItems = Number(settingsItem.numberOfListItems.value);
      const hasFacets = Boolean(settingsItem.indexSource.targetItem.availableFacets);
      const facetsSchema = hasFacets ? settingsItem.indexSource.targetItem.availableFacets.targetItems : [];
      // List of facet names, which will require separate query to fetch proper amount of items.
      const activeMultiSelectableFacets = [];
      const facetNames = facetsSchema.map(item => {
        if (
        // Only include if facet is being actively filtered now, otherwise it contains maximum amount of items.
        this.state.filters[item.facetName.value]) {
          activeMultiSelectableFacets.push(item.facetName.value);
        }
        return item.facetName.value;
      });
      const featuredItemsQty = settingsItem.numberOfFeaturedItems ? Number(settingsItem.numberOfFeaturedItems.value) : 0;
      const amountOfResultsToFetch = featuredItemsQty + numberOfListItems;
      const algoliaSettings = {
        key: get(this.context, 'configuration.algolia.algoliaApiKey'),
        id: get(this.context, 'configuration.algolia.algoliaApplicationId'),
        fullTextSearchIndex: get(this.context, 'configuration.algolia.fullTextSearchIndex')
      };

      // Direct client is required for multiQueries search
      algoliaModule.getClient(algoliaSettings).then(client => {
        // @todo handle different errors from Algolia.

        const commonSearchArguments = {
          indexName: algoliaModule.getFullIndexName(indexNameSuffix, algoliaSettings.fullTextSearchIndex),
          query: ''
        };
        const language = this.context.language || 'en';

        // filtering results to exclude the current page by item id
        const currentPageId = `${language}_${get(this.props, 'route.itemId', '')}`;
        const resultsQueries = [_objectSpread(_objectSpread({}, commonSearchArguments), {}, {
          params: {
            facetFilters: algoliaModule.getFiltersFromCheckboxes(this.getMergedValidatedFilters()),
            filters: currentPageId ? `NOT objectID:${currentPageId.toLowerCase()}` : '',
            // we hardcore attributes to retrieve, because react components hardly depends on them.
            attributesToRetrieve: ['pagetitle', 'pageintro', 'category', '__updated', 'dateofissue', 'isfeatured', 'businessunit', 'announcementtype', 'author', 'location', '_id', 'headerimage', 'url'],
            hitsPerPage: amountOfResultsToFetch,
            facets: facetNames,
            page: this.state.page
          }
        })];

        // Each active facet requires additional light search request to fetch all available amounts
        // eslint-disable-next-line array-callback-return
        activeMultiSelectableFacets.map(facetName => {
          resultsQueries.push(_objectSpread(_objectSpread({}, commonSearchArguments), {}, {
            params: {
              // Facet amounts has to respect filters from other facets, because by default other facets are
              // applied with AND condition.
              facetFilters: algoliaModule.getFiltersFromCheckboxes(this.getMergedValidatedFilters(), facetName),
              facets: [facetName],
              hitsPerPage: 1,
              attributesToRetrieve: [],
              attributesToHighlight: [],
              page: 0
            }
          }));
        });
        return client.search(resultsQueries).then(response => {
          const {
            results
          } = response;
          const pureFacets = {};
          const {
            facets,
            hits,
            nbHits,
            nbPages
          } = results[0];

          // Fetch proper facet amounts from additional searches.
          // eslint-disable-next-line array-callback-return
          activeMultiSelectableFacets.map((facetName, index) => {
            if (results[index + 1].facets && results[index + 1].facets[facetName]) {
              pureFacets[facetName] = results[index + 1].facets[facetName];
            }
          });
          this.setState(prevState => ({
            hits: this.state.page === 0 ? hits : [...prevState.hits, ...hits],
            facets: _objectSpread(_objectSpread({}, facets), pureFacets),
            nbHits,
            nbPages
          }));
        }).catch(err => {
          console.error(err);
          // @todo should we just fallback to previous results?
          this.setState({
            hits: [],
            facets: {},
            nbHits: 0,
            nbPages: 0
          });
        });
      }).catch(err => {
        // something happened during client initialization or shortly thereafter
        console.error(err);
      });
    };
  }
  componentDidMount() {
    const filters = {};
    if (Array.from(this.props.location.search).length) {
      const search = new URLSearchParams(this.props.location.search);
      search.forEach((value, key) => {
        filters[key] = value.split(splitter);
      });
    }
    this.setState({
      filters
    });
    import(/* webpackChunkName: "AlgoliaModule" */'../../utils/algolia').then(mod => {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        algoliaModule: mod.default
      }));
      this.loadSearchResults();
    });
  }
  componentDidUpdate(prevProps, prevState, nextContext) {
    // There is dependency on context.language as well, however it should not change without
    // full page reload, so we can avoid it here, because componentDidUpdate can not work with it anyway.

    if (this.state.filters !== prevState.filters || this.state.page !== prevState.page || this.props.fields.data.settingsItem !== prevProps.fields.data.settingsItem || this.props.fields.data.contextItem !== prevProps.fields.data.contextItem) {
      this.loadSearchResults();
    }
  }
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this.state !== nextState;
  }
  render() {
    const settingsItem = get(this.props, 'fields.data.settingsItem');
    if (!settingsItem) {
      console.info("[DynamicListingComponent] settings item wasn't resolved. returning from render.");
      return null;
    }
    const {
      bannerClickAnalytics,
      listingItemAnalytics,
      seeMoreAnalytics,
      filtersClickAnalytics,
      fitlersCategoryAnalytics,
      fitlersClearAnalytics,
      fitlersValueAnalytics,
      filtersShowResultsAnalytics,
      featuredReadMoreAnalytics,
      listingLoadMoreAnalytics,
      featuredBannerClickAnalytics,
      featuredTitleClickAnalytics,
      listingBannerClickAnalytics,
      listingTitleClickAnalytics,
      eventsAnalytics
    } = this.props.fields.data;
    const params = get(this.props, 'params');
    const viewedNofMLabel = get(settingsItem, 'viewedNofMLabel.value', "You've viewed {#loadedHits#} of {#nbHits#} items");
    const showNResultsLabel = get(settingsItem, 'showNResultsLabel.value', 'Show {#resultsAmount#} results');
    const cancelLabel = get(settingsItem, 'cancelLabel.value', 'Cancel');
    const clearAllButtonLabel = get(settingsItem, 'clearAllButtonLabel.value', 'Clear All');
    const clearButtonLabel = get(settingsItem, 'clearButtonLabel.value', 'Clear');
    const filtersButtonLabel = get(settingsItem, 'filtersButtonLabel.value', 'Filters');
    const hasFacets = Boolean(settingsItem.indexSource.targetItem.availableFacets);
    const facetsSchema = hasFacets ? settingsItem.indexSource.targetItem.availableFacets.targetItems : [];
    const isColoured = Boolean(settingsItem.colourTheme.targetItem);
    const featuredItemsQty = settingsItem.numberOfFeaturedItems ? Number(settingsItem.numberOfFeaturedItems.value) : 0;
    const rtl = Boolean(this.context && this.context.rtl);
    const pageEditing = Boolean(this.context && this.context.pageEditing);
    const hasItems = Boolean(this.state.hits && this.state.hits.length);
    const featuredItems = hasItems ? this.state.hits.slice(0, featuredItemsQty).filter(hit => hit.isfeatured) : [];
    const items = hasItems && this.state.hits.length > featuredItems.length ? this.state.hits.slice(featuredItems.length) : [];

    // To render three elements per row and keep proper layout.
    const groupedItems = items.reduce((rows, item, index) => {
      index % 3 === 0 ? rows.push([item]) : rows[rows.length - 1].push(item);
      return rows;
    }, []);
    if (!hasItems) {
      return pageEditing ? /*#__PURE__*/React.createElement("div", null, "There are no search results. Most likely taxonomy settings are too restrictive or no results for current language.") : null;
    }
    return /*#__PURE__*/React.createElement(StyledWrapper, {
      anchorUrlParameter: params['Anchor Url Parameter'],
      rtl: rtl
    }, /*#__PURE__*/React.createElement("div", {
      className: `${commonStyle}`
    }, this.state.facets && Object.keys(this.state.facets).length > 0 && /*#__PURE__*/React.createElement(FilterBlock, {
      facetsSchema: facetsSchema,
      facets: this.state.facets,
      setFilters: this.setFilters,
      resultsAmount: this.state.nbHits,
      filters: this.state.filters,
      showNResultsLabel: showNResultsLabel,
      cancelLabel: cancelLabel,
      clearAllButtonLabel: clearAllButtonLabel,
      clearButtonLabel: clearButtonLabel,
      filtersButtonLabel: filtersButtonLabel,
      filtersClickAnalytics: filtersClickAnalytics,
      fitlersCategoryAnalytics: fitlersCategoryAnalytics,
      fitlersClearAnalytics: fitlersClearAnalytics,
      fitlersValueAnalytics: fitlersValueAnalytics,
      filtersShowResultsAnalytics: filtersShowResultsAnalytics,
      params: params,
      rtl: rtl
    }), featuredItems.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: `news-featured${settingsItem.title ? ' news-featured--has-heading' : ''}${isColoured ? ' news-featured--highlighted' : ''} ${settingsItem.title.value === '' ? 'news-featured--no-heading' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "news-featured__highlighter"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-xl-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-xl-11"
    }, /*#__PURE__*/React.createElement("div", {
      className: "news-featured__heading-sec"
    }, settingsItem.title && /*#__PURE__*/React.createElement(Text, {
      className: "h2 news-featured__heading",
      tag: "h2",
      field: settingsItem.title
    })))), featuredItems.length > 0 && featuredItems.slice(0, 1).map(item => /*#__PURE__*/React.createElement(FeaturedResultItem, {
      key: item.__updated,
      item: item,
      rtl: rtl,
      readFeaturedLabel: settingsItem.readFeaturedLabel,
      language: this.context.language,
      analytics: {
        data: {
          featuredReadMoreAnalytics: featuredReadMoreAnalytics,
          featuredBannerClickAnalytics: featuredBannerClickAnalytics,
          featuredTitleClickAnalytics: featuredTitleClickAnalytics,
          eventsAnalytics: eventsAnalytics
        },
        params
      }
    }))), featuredItems.length > 1 && featuredItems.slice(1, featuredItems.length).map(item => /*#__PURE__*/React.createElement("div", {
      key: item.__updated,
      className: "news-featured"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-xl-11"
    }, /*#__PURE__*/React.createElement("div", {
      className: "news-featured__heading-sec"
    }))), /*#__PURE__*/React.createElement(FeaturedResultItem, {
      item: item,
      rtl: rtl,
      readFeaturedLabel: settingsItem.readFeaturedLabel,
      language: this.context.language,
      analytics: {
        data: {
          featuredReadMoreAnalytics: featuredReadMoreAnalytics,
          featuredBannerClickAnalytics: featuredBannerClickAnalytics,
          featuredTitleClickAnalytics: featuredTitleClickAnalytics,
          eventsAnalytics: eventsAnalytics
        },
        params
      }
    })))), featuredItems.length === 0 && settingsItem.title && /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-xl-11"
    }, /*#__PURE__*/React.createElement(Text, {
      className: "h3 news__heading-multiple",
      tag: "h3",
      field: settingsItem.title
    }))), hasItems && /*#__PURE__*/React.createElement(React.Fragment, null, groupedItems.map((rowItems, index) => /*#__PURE__*/React.createElement("div", {
      className: "row",
      key: `results-row-${index}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-1"
    }), rowItems.map(item => /*#__PURE__*/React.createElement(ResultItem, {
      item: item,
      key: item._id,
      language: this.context.language,
      analitycs: {
        listingItemAnalytics: listingItemAnalytics,
        bannerClickAnalytics: bannerClickAnalytics
      },
      params: params
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-xl-2"
    }))), settingsItem.listingPage && settingsItem.seeMoreLabel && /*#__PURE__*/React.createElement(SeeMoreButton, {
      listingPage: settingsItem.listingPage,
      seeMoreLabel: settingsItem.seeMoreLabel,
      rtl: rtl,
      pageEditing: pageEditing,
      analitycs: seeMoreAnalytics,
      params: params
    }), settingsItem.loadMoreLabel && this.state.nbPages - 1 > this.state.page && /*#__PURE__*/React.createElement(LoadMore, {
      buttonLabel: settingsItem.loadMoreLabel.value,
      onClick: () => {
        this.loadMore();
        tealiumClickFunc(tealiumMergeClickData(listingLoadMoreAnalytics, params));
      },
      nbHits: this.state.nbHits,
      loadedHits: this.state.hits.length,
      viewedNofMLabel: viewedNofMLabel
    }))));
  }
}
DynamicListingComponent.contextType = SitecoreContextReactContext;
const commonStyle = "c1mwupbq";
const featuredResultItemStylesLtr = "f1tm4b59";
const featuredResultItemStylesRtl = "f12qtyxw";
const resultItemStylesLtr = "r1pju169";
const resultItemStylesRtl = "rnje00p";
export const loadMoreButtonStylesLtr = "l9grpxt";
const loadMoreButtonStylesRtl = "l1uzvc3v";
export const filtersStylesLtr = "f1s5tic2";
export const filtersStylesRtl = "f1dbvngk";
const toggleMultiSelectStylesLtr = "t1xylat4";
const toggleMultiSelectStylesRtl = "t1s7nib9";
const toggleSingleSelectStylesLtr = "t14hk01b";
const toggleSingleSelectStylesRtl = "t15ikf69";
const baseStylesLtr = "b1mp6ke4";
const baseStylesRtl = "b13pp662";
const ltrStylesCLasses = `
${baseStylesLtr}
${featuredResultItemStylesLtr}
${filtersStylesLtr}
${loadMoreButtonStylesLtr}
${resultItemStylesLtr}
${toggleMultiSelectStylesLtr}
${toggleSingleSelectStylesLtr}
`;
const rtlStylesCLasses = `
${baseStylesRtl}
${featuredResultItemStylesRtl}
${filtersStylesRtl}
${loadMoreButtonStylesRtl}
${resultItemStylesRtl}
${toggleMultiSelectStylesRtl}
${toggleSingleSelectStylesRtl}
`;
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${rtl ? rtlStylesCLasses : ltrStylesCLasses} ${legislationStyles}`
  }, children);
};
const legislationStyles = "l1hqfnau";
export default withRouter(DynamicListingComponent);